var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBouncingBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 112,
    viewBox: "0 0 121 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.874 0V7.22796H103.114V0H103.874Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8719 4.59277L89.4859 10.8527L88.8279 11.2326L85.2139 4.9727L85.8719 4.59277Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5791 17.5723L78.839 21.1862L78.4591 21.8443L72.1992 18.2303L72.5791 17.5723Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5566 35.459H74.7846V36.2189H67.5566V35.459Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8967 52.415C97.8967 62.4044 94.0076 71.795 86.9438 78.8588C79.8799 85.9226 70.4894 89.8117 60.5 89.8117V78.7783C75.038 78.7783 86.8647 66.9515 86.8647 52.415H97.8967Z",
    fill: "#6BB6FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.085 52.415C120.085 60.4561 118.509 68.26 115.401 75.6096C112.4 82.7053 108.103 89.0776 102.634 94.5473C97.1628 100.018 90.7919 104.313 83.6962 107.315C76.3466 110.424 68.5427 112 60.5001 112C52.4576 112 44.6552 110.424 37.3056 107.315C30.2099 104.313 23.8375 100.018 18.3679 94.5473C12.8968 89.0776 8.60197 82.7053 5.60045 75.6096C2.49255 68.26 0.915039 60.4561 0.915039 52.415H11.9485C11.9485 65.3831 16.9986 77.5761 26.1688 86.7463C35.3391 95.9165 47.5321 100.967 60.5001 100.967C73.4682 100.967 85.6628 95.9165 94.833 86.7463C104.003 77.5761 109.053 65.3831 109.053 52.415H120.085Z",
    fill: "#00EC25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.947 19.2629H0.915039V52.4149H11.947V19.2629Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1048 19.2632H11.9482V52.4152H23.1048V19.2632Z",
    fill: "#FFCEC2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1374 19.2632H23.1055V52.4152H34.1374V19.2632Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.086 19.2632H86.8652V52.4152H120.086V19.2632Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.086 52.4152L103.476 35.9517L86.8652 52.4152H120.086Z",
    fill: "#006EF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.086 35.9516L103.476 19.488L86.8652 35.9516H120.086Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3769 93.4986H10.6748V92.7388H24.3769V93.4986Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3769 97.9025H10.6748V97.1426H24.3769V97.9025Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3769 102.309H10.6748V101.549H24.3769V102.309Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5006 78.7783V89.8117C50.5128 89.8117 41.1207 85.9211 34.0584 78.8588C26.9945 71.795 23.1055 62.4044 23.1055 52.415H34.1374C34.1374 66.9515 45.9641 78.7783 60.5006 78.7783Z",
    fill: "#FFCEC2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.053 52.4149C109.053 65.3829 104.003 77.5759 94.8328 86.7462C85.6626 95.9164 73.4696 100.967 60.5 100.967V89.8115C70.4894 89.8115 79.8815 85.9209 86.9438 78.8586C94.0061 71.7963 97.8967 62.4042 97.8967 52.4149L103.476 47.7173L109.053 52.4149Z",
    fill: "#006EF5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.053 52.4149L103.476 56.7462L97.8965 52.4149L103.476 47.7173L109.053 52.4149Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBouncingBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BouncingBack.ec2aae073549a84a2d05aabc2d8feed3.svg";